module.exports = __webpack_public_path__ + "img/abra.f1dc8703.jpg";